export enum ActivityEntityName {
    Job = 'Job',
    JobCreate = 'Job Create',
    /** Import-only schema: bulk-update of schedule dates on existing jobs, matched by job number. */
    JobSchedule = 'Job Schedule',
    /** Import-only schema: bulk-update of schedule dates on existing stages, matched by stage number. */
    StageSchedule = 'Stage Schedule',
    /** Import-only schema: bulk add/remove of site tags on existing sites, matched by place id. Hazards (alert-enabled site tags) are the driving use case. */
    SiteTags = 'Site Tags',
    /** Import-only schema: bulk add/remove of postcode membership on existing zones, matched by zone name. */
    ZonePostcode = 'Zone Postcode',
    WorkOrder = 'WorkOrder',
    WorkOrderResource = 'WorkOrderResource',
    Customer = 'Customer',
    Quote = 'Quote',
    QuoteJob = 'Quote Job',
    QuoteOpportunity = 'Quote Opportunity',
    QuotePro = 'Quote Pro',
    QuoteSection = 'Quote Section',

    Work = 'Work',
    WorkItem = 'Work Item',

    // Virtual entities for items management (aggregates embedded codes)
    JobItem = 'Job Item',
    NativeJobGantt = 'Native Job Gantt',
    StageItem = 'Stage Item',
    /** Virtual entity: items-board leaf. Same fields as EmbeddedCode, own view namespace. */
    EmbeddedItem = 'Embedded Item',
    StageTemplate = 'Stage Template',

    PurchaseOrder = 'PO',
    PurchaseOrderLine = 'PO Line',
    PurchaseOrderLines = 'PO Lines',
    PurchaseOrderSupplier = 'PO Supplier',
    PurchaseOrderDeliveryAddress = 'PO Delivery Address',

    Invoice = 'Invoice',
    BulkAction = 'BulkAction',
    BulkInvoice = 'BulkInvoice',
    BulkInvoiceJob = 'BulkInvoiceJob',

    /** This is a variant of invoice used for entity data provider */
    InvoiceSite = 'InvoiceSite',

    InvoiceContact = 'InvoiceContact',
    InvoiceBillingCompany = 'InvoiceBillingCompany',

    PrepaymentInvoice = 'Prepayment Invoice',
    PrepaymentSupplier = 'Prepayment Supplier',

    CreditNote = 'Credit Note',
    CreditNoteSupplier = 'Credit Note Supplier',

    Bill = 'Bill',
    None = 'None',
    Compliance = 'Compliance',

    AccountingPackage = 'Accounting Package',

    Payment = 'Payment',
    /** Tenant payment methods (`payment_methods`). Picker-only: it exists so `Payment.method` filters through a real Lookup. */
    PaymentMethod = 'Payment Method',
    TimeSegment = 'Time Segment',
    TimeSheet = 'Time Sheet',
    TimeSheetLog = 'Time Sheet Log',
    TimeSheetDuration = 'Time Sheet Duration',
    TimeSheetBillingOption = 'Time Sheet Billing Option',
    TimeSheetRate = 'Time Sheet Rate',
    TimeSheetTotal = 'Time Sheet Total',

    Contact = 'Contact',
    Employee = 'Employee',
    Team = 'Team',
    ContactEmployee = 'Contact Employee',
    ContactInvite = 'Contact Invite',
    /** Virtual entity: combines Employee + LoginContact for form submitter lookups */
    LoginableContact = 'Loginable Contact',
    /** Virtual entity: Job owner candidates — Employee + LoginContact whose parent is a Contractor (Subcontractor) */
    JobOwner = 'Job Owner',

    Account = 'Account',
    Zone = 'Zone',
    Allocation = 'Allocation',
    CreditAllocation = 'Credit Allocation',
    Code = 'Code',
    EmbeddedCode = 'Embedded Code',
    Item = 'Item',
    ItemPending = 'Item Pending',
    Utility = 'Utility',
    Upgrade = 'Upgrade',

    Asset = 'Asset',
    AssetLink = 'AssetLink',
    AssetCustomer = 'AssetCustomer',

    EquipmentLink = 'EquipmentLink',

    Equipment = 'Equipment',

    EquipmentBulk = 'Equipment-Bulk',
    EquipmentSerialised = 'Equipment-Serialised',
    EquipmentVehicle = 'Equipment-Vehicle',

    EquipmentInternalSerialised = 'Equipment-Internal-Serialised',
    EquipmentInternalVehicle = 'Equipment-Internal-Vehicle',

    EquipmentCreate = 'Equipment-Create',
    EquipmentBulkCreate = 'Equipment-Bulk-Create',
    EquipmentSerialisedCreate = 'Equipment-Serialised-Create',
    EquipmentVehicleCreate = 'Equipment-Vehicle-Create',

    StockLocationEquipment = 'Stock Location Equipment',
    StockLocation = 'Stock Location',
    StockMovement = "Stock Movement",
    StockLevel = 'Stock Level',

    Defect = 'Defect',
    WorkRole = 'Work Role',
    Resource = 'Resource',
    JobTemplate = 'Job Template',
    Lead = 'Lead',
    Opportunity = 'Opportunity',
    OpportunityStage = 'Opportunity Stage',
    OpportunityAccount = 'Opportunity Account',
    //DO NOT REMOVE, NEED TO USE THIS AS IT CORRESPONDS TO THE OLD CONTACT TYPE OF SITE, WHICH IS USED IN THE CRM
    Site = 'Site',
    ///
    SitePro = 'Site Pro',
    SiteTiny = 'Site Tiny',
    ManagedSite = 'Managed Site',
    AccountSite = 'Account Site',
    SiteProValidated = 'Site Pro Validated',
    SiteContactValidated = 'Site Contact Validated',
    SiteProContacts = 'Site Pro Contacts',

    Company = 'Company',
    CustomFields = 'Custom Fields',
    Variation = 'Variation',
    SaleOrder = "Sale Order",
    SaleOrderItems = "Sale Order Items",

    WorkType = 'Work Type',
    JobType = 'JobType',
    Supplier = 'Supplier',
    Contractor = 'Contractor',
    PriceList = 'PriceList',
    TaxRate = 'TaxRate',
    Address = 'Address',
    Link = 'Link',
    Activity = 'Activity',
    Form = 'Form',
    FormResponse = 'FormResponse',
    FormResponseLink = 'FormResponseLink',
    FormTemplate = 'FormTemplate',
    SecurityRole = 'Security Role',
    TenantSetting = 'Tenant Setting',
    /** Singleton tenant general-settings document. Not a collection entity. */
    GeneralSetting = 'General Setting',
    /** Tenant public-holiday extras and shadows over a generated statewide calendar. */
    PublicHoliday = 'Public Holiday',
    Catalogue = 'Catalogue',

    Project = 'Project',
    CodeCategory = 'Code Category',
    UoM = 'UoM',
    CodeUoM = 'Code UoM',
    AssetType = 'Asset Type',
    Priority = 'Priority',

    Task = 'Task',
    /** Definition rows in `tasktemplates`, scoped by a checklist / job template / recurring job parent. */
    TaskTemplate = 'Task Template',
    Attachment = "Attachment",

    QuoteTemplate = 'Quote Template',
    DocumentTheme = 'Document Theme',
    UOM = 'UOM',
    JobStatus = 'Job Status',
    WorkOrderStatus = 'Work Order Status',
    BasicContact = 'Basic Contact',
    LoginContact = 'Login Contact',
    JobPolicy = "Job Policy",
    QuotePolicy = "Quote Policy",
    File = "File",
    /** Document-library merge templates (task / SLT fileTemplate). Not File attachments. */
    FileTemplate = "FileTemplate",
    Tag = "Tag",
    JobStages = "Job Stages",
    WorkBuddyCompany = "WorkBuddyCompany",

    RecurringJob = "Recurring-Job",
    // Virtual entities for the Recurring Job items board (aggregates the embedded template codes).
    // Same three-level shape as JobItem → StageItem → EmbeddedItem, but rooted on `recurringjobs`
    // and reaching the codes through `jobTemplate.template.workOrders[].codes[]`.
    RecurringJobTemplateItem = "Recurring-Job-Template-Item",
    RecurringJobTemplateStage = "Recurring-Job-Template-Stage",
    /** Virtual entity: recurring-job items-board leaf. Same fields as JobTemplateCode, own view namespace. */
    RecurringJobTemplateCode = "Recurring-Job-Template-Code",
    // Same three-level shape as the recurring-job chain above, one level shallower. Cannot reuse those
    // names: one entity name binds to exactly one root schema token.
    JobTemplateItem = "Job-Template-Item",
    JobTemplateStage = "Job-Template-Stage",
    /** Virtual entity: job-template items-board leaf. Same fields as the RJ leaf, own view namespace. */
    JobTemplateCode = "Job-Template-Code",
    // Virtual entities for the Job Template questions board, over `template.questions[]`. Two levels
    // rather than three: a question is a direct child of the template.
    JobTemplateQuestions = "Job-Template-Questions",
    JobTemplateQuestion = "Job-Template-Question",
    // Not boards: they let the two defaults forms bind ROOT-relative, which is what expands the
    // custom-fields marker and picks its owner — Job on one scope, Opportunity on the other.
    JobTemplateJobDefaults = "Job-Template-Job-Defaults",
    JobTemplateOpportunityDefaults = "Job-Template-Opportunity-Defaults",
    RecurringService = "Recurring-Service",
    RecurringNextService = "RecurringNextService",
    RecurringLastService = "RecurringLastService",
    RecurringSchedule = "RecurringSchedule",
    RecurringRule = "RecurringRule",
    RecurringConfirmation = 'RecurringConfirmation',
    ServicePlan = 'Service Plan',
    ServicePlanTemplate = 'Service Plan Template',
    /**
     * Virtual board row: a planned task due in a date-of-work window, joined with its Service Plan
     * (type, scope, site, customer) and Service Line (work category).
     */
    UpcomingWork = 'Upcoming Work',
    /** Virtual board row (plan section 19): one customer's past approved task or period-target result. */
    ServiceHistory = 'Service History',
    /** Virtual board row: a compliance overdue Flag joined with its plan's customer and its line's owner. */
    ComplianceFlag = 'Compliance Flag',
    ServiceLine = 'Service Line',
    /** One collection for every planned-work catalogue line and Visit item exception; parent pointer selects the owner. */
    PlannedItem = 'Planned Item',
    /** One collection for every planned-work task — live, template and Visit exception; parent pointer selects the owner. */
    PlannedTask = 'Planned Task',
    /** Virtual read projection: a parent's planned tasks as a tree, standing or Visit-resolved. */
    PlannedTaskOutline = 'Planned Task Outline',
    /**
     * The four PARENT TYPES a `PlannedTask` or `PlannedItem` may point at.
     *
     * These are no longer collections — `planned_tasks` and `planned_items` replaced all four of the
     * task and item ones — but they remain the vocabulary a parent pointer is written in, which is how
     * one row knows whether it hangs off a live line, a live task, or either template twin. The
     * template names stay distinct from the live ones on purpose: that distinction is what a repository
     * reads to strip live-only scheduling state from a template row.
     */
    ServiceLineTask = 'Service Line Task',
    ServiceLineTemplate = 'Service Line Template',
    ServiceLineTaskTemplate = 'Service Line Task Template',
    Visit = 'Visit',
    VisitApproval = 'VisitApproval',
    VisitApprovalReview = 'VisitApprovalReview',
    VisitApprovalVisit = 'VisitApprovalVisit',
    VisitApprovalRevision = 'VisitApprovalRevision',

    EntityLink = 'Entity Link',

    EntityStatus = 'Entity Status',
    EntitySubStatus = 'Entity Sub Status',
    ContactLink = "ContactLink",
    ServiceConfirmation = 'Service Confirmation',

    InboundEmail = 'InboundEmail',
    InboundEmailConfiguration = 'InboundEmailConfiguration',
    PostmarkEmail = 'PostmarkEmail',

    /** This is used to provide entity pickers for operations based on the view */
    LegacyJob = 'LegacyJob',
    ServiceEntity = "ServiceEntity",

    WorkOrderDispatch = 'WorkOrderDispatch',
    PurchaseOrderBillingCompany = "PurchaseOrderBillingCompany",
    PurchaseOrderAccountingPackage = "PurchaseOrderAccountingPackage", // Use in document theme

    /** Virtual Entity: use for entity data */
    JobAsset = 'Job Asset',
    AssetRecurringJob = 'Asset Recurring Job',

    Agreement = 'Agreement',

    HomesNSWNotice = 'HomesNSWNotice',
    HomesNSWNoticeLineItem = 'HomesNSWNoticeLineItem',
    HomesNSWOutboundMessage = 'HomesNSWOutboundMessage',

    IntegrationApiLog = 'IntegrationApiLog',
    IntegrationEventResult = 'IntegrationEventResult',
    HomesVICIngestionRecord = 'HomesVICIngestionRecord',

    BifEvent = 'BifEvent',

    Tenant = 'Tenant',
    WorkCategory = 'WorkCategory',
    OAuth2Application = "OAuth2Application",
    Agent = 'Agent',

    /** This is used to provide the picker for enttiy specifc contacts used for email and sms in the activity editor */
    EntityContacts = 'EntityContacts',

    IpRestriction = 'IpRestriction',
    MaterialisedView = 'MaterialisedView',
    MaterialisedViewSource = 'MaterialisedViewSource',
    FeatureFlag = 'FeatureFlag',

    AIProcessInbox = 'AIProcessInbox',
    AITaskValidationInbox = 'AITaskValidationInbox',
    AgentActionInbox = 'AgentActionInbox',

    AuditLog = 'AuditLog',
    CodePrice = "CodePrice",

    Notification = 'Notification',
    EmailDigest = 'EmailDigest',
    BrowserPushSubscription = 'BrowserPushSubscription',
    InboxMessage = 'InboxMessage',
    OutboxMessage = 'OutboxMessage',
    WebhookSubscription = 'WebhookSubscription',

    PriceListRule = 'PriceListRule',
    ContractorCapacity = 'Contractor Capacity',
    SitePricing = 'Site Pricing',

    Flag = 'Flag',

    BusinessRuleConfig = 'BusinessRuleConfig',

    /** Engine-owned per-rule runtime state (last run / next due). Separate entity from the config. */
    BusinessRuleExecutionState = 'BusinessRuleExecutionState',

    /** Virtual metadata-only entity: candidate shape for BRC invoice-consolidation rules. */
    BrcConsolidationCandidate = 'BRC Consolidation Candidate',

    EntityQueue = 'Entity Queue',

    /** Admin board over queue records themselves; EntityQueue serves the rows inside a queue. */
    EntityQueueDefinition = 'Queue Definition',
}
